import { render, staticRenderFns } from "./HrgaReport.vue?vue&type=template&id=ef5cc340"
import script from "./HrgaReport.vue?vue&type=script&lang=js"
export * from "./HrgaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports